import React from 'react';
import { Rate } from 'antd';

const ratings = [
  {
    id: '1',
    name: <Rate disabled defaultValue={1} style={{ fontSize: 14 }} />,
  },
  {
    id: '2',
    name: <Rate disabled defaultValue={2} style={{ fontSize: 14 }} />,
  },
  {
    id: '3',
    name: <Rate disabled defaultValue={3} style={{ fontSize: 14 }} />,
  },
  {
    id: '4',
    name: <Rate disabled defaultValue={4} style={{ fontSize: 14 }} />,
  },
  {
    id: '5',
    name: <Rate disabled defaultValue={5} style={{ fontSize: 14 }} />,
  },
  {
    id: 'б/о',
    name: 'Без оценки',
  },
];

export const initialRatingsMap = new Map(
  ratings.map((rating) => [
    rating.id,
    { id: rating.id, name: rating.name, value: 0, percent: 0 },
  ])
);

initialRatingsMap.set('0', { id: '0', name: 'Не указано', value: 0, percent: 0 });

export default ratings;
